import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import partial from 'lodash/partial';

import colors from '../../../../styling/colors';

const TabContainer = styled.div``;

const TabRow = styled.ul`
  border-bottom: solid 1px ${colors('gallery')};
  display: flex;
  justify-content: space-around;
  list-style: none;
  margin: 0;
  padding: 1.25rem 0 0;
  width: 100%;
`;

const TabTitle = styled.li`
  cursor: pointer;
  text-align: center;
  width: 50%;

  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

const TabText = styled.span`
  color: ${({ selected }) => (selected ? colors('lapel') : colors('silver'))};
  display: inline-block;
  padding: 0 1rem ${({ selected }) => (selected ? '0.75rem' : '0.875rem')};
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${({ selected }) =>
    selected && `border-bottom: solid 2px ${colors('gatsby')}`};
`;

export class Tab extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return <TabContainer>{this.props.children}</TabContainer>;
  }
}

export class Tabs extends Component {
  static propTypes = {
    children: PropTypes.arrayOf(PropTypes.element),
    onChange: PropTypes.func,
  };

  state = {
    selectedTab: 0,
  };

  onClick = index => {
    this.setState({
      selectedTab: index,
    });

    const { onChange } = this.props;
    if (onChange) {
      onChange(index);
    }
  };

  render() {
    const { children } = this.props;
    const { selectedTab } = this.state;

    const tabTitles = children.map((child, i) => {
      return (
        <TabTitle key={i} onClick={partial(this.onClick, i)}>
          <TabText selected={i === selectedTab}>{child.props.title}</TabText>
        </TabTitle>
      );
    });

    const tab = children[selectedTab];

    return (
      <div>
        <TabRow>{tabTitles}</TabRow>
        {tab}
      </div>
    );
  }
}
